/* eslint-disable react/prop-types */
import React from 'react'
import { HeartIcon } from '@heroicons/react/24/solid'
import { useTheme } from '../../utils/ThemeColorContext'
import { AppStyles } from '../../assets/styles/AppStyles'
import DocumentSolid from '../../assets/icons/DocumentSolid.svg'
import Document from '../../assets/icons/Document.svg'
import { Check, Clock } from '../../assets/AppIcons'

const STEPS = [
  { icon: Document, label: "We're reviewing your information" },
  { icon: Clock, label: 'Checking your eligibility' },
  { icon: Check, label: 'Getting your decision ready' },
]

const SpinningRing = ({ color }) => (
  <svg
    aria-hidden="true"
    className="w-6 h-6 animate-spin shrink-0"
    viewBox="0 0 24 24"
    fill="none"
  >
    <circle
      cx="12"
      cy="12"
      r="9"
      stroke={color}
      strokeOpacity="0.2"
      strokeWidth="3"
    />
    <circle
      cx="12"
      cy="12"
      r="9"
      stroke={color}
      strokeWidth="3"
      strokeLinecap="round"
      strokeDasharray="14 43"
    />
  </svg>
)

const CheckingYourInfoCard = () => {
  const { color, isSmallScreen } = useTheme()
  return (
    <div className="flex items-center justify-center px-4 pt-8 md:p-0 md:min-h-[calc(100vh-236px)]">
      <div
        role="status"
        style={{ backgroundColor: color.White }}
        className="w-full md:w-[564px] p-6 md:p-10 rounded-3xl flex flex-col items-center"
      >
        <img src={DocumentSolid} alt="" className="w-12 h-12 mb-6" />
        <h1
          style={{ ...AppStyles.Title1, color: color.Plum }}
          className="text-center mb-4"
        >
          Checking your info
        </h1>
        <p
          style={{
            ...(isSmallScreen ? AppStyles.Body : AppStyles.Body16),
            color: color.Grey,
          }}
          className="text-center mb-6"
        >
          We&apos;re just checking your details and making sure you&apos;re
          eligible for an Updraft loan. This will only take a few minutes.
        </p>
        <div className="w-full space-y-4">
          {STEPS.map(({ icon, label }) => (
            <div
              key={label}
              style={{ borderColor: color.MidGrey }}
              className="flex items-center border rounded-2xl px-4 py-5 space-x-4"
            >
              <img src={icon} alt="" className="w-6 h-6 shrink-0" />
              <p
                style={{ ...AppStyles.BodyBold, color: color.Plum }}
                className="flex-1"
              >
                {label}
              </p>
              <SpinningRing color={color.Blurple} />
            </div>
          ))}
        </div>
        <div className="w-full flex items-start space-x-4 px-4 mt-8">
          <HeartIcon
            aria-hidden="true"
            className="w-6 h-6 shrink-0"
            style={{ color: color.Blurple }}
          />
          <div>
            <p style={{ ...AppStyles.BodyBold, color: color.Plum }}>
              You&apos;ve taken a great step towards more financial freedom.
            </p>
            <p style={{ ...AppStyles.Caption1, color: color.Grey }}>
              We&apos;re here to help every step of the way
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CheckingYourInfoCard
